import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import SiteLayout from './components/layout/SiteLayout';
import Home from './components/Home';
import Base64Converter from './components/Base64Converter';
import PasswordGenerator from './components/PasswordGenerator';
import GuidGenerator from './components/GuidGenerator';
import StringUtilities from './components/StringUtilities';
import JsonFormatter from './components/JsonFormatter';
import JwtDecoder from './components/JwtDecoder';

function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/password-generator" element={<PasswordGenerator />} />
        <Route path="/base64-converter" element={<Base64Converter />} />
        <Route path="/guid-generator" element={<GuidGenerator />} />
        <Route path="/string-utilities" element={<StringUtilities />} />
        <Route path="/json-formatter" element={<JsonFormatter />} />
        <Route path="/jwt-decoder" element={<JwtDecoder />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
